import { decodeOverrides, OverridesCookieName, } from '@coolblue-development/next-request-context-utils';
import { cookies } from 'next/headers.js';
export const getOverrides = () => {
    var _a;
    const cookieValue = (_a = cookies().get(OverridesCookieName)) === null || _a === void 0 ? void 0 : _a.value;
    if (!cookieValue) {
        return {};
    }
    return decodeOverrides(cookieValue);
};
export const getOverride = (name) => {
    return getOverrides()[name];
};
//# sourceMappingURL=getOverrides.js.map